$(document).ready(function () {
    jQuery.validator.addMethod("mustContainState", function (value, element) {
        return this.optional(element) || (value.indexOf(",") > 0 && value.split(',')[1].trim() !== "");
    }, "* A state or province is required");
});